import { render } from "./FeedbackModal.vue?vue&type=template&id=3fc68044&scoped=true"
import script from "./FeedbackModal.vue?vue&type=script&lang=js"
export * from "./FeedbackModal.vue?vue&type=script&lang=js"

import "./FeedbackModal.vue?vue&type=style&index=0&id=3fc68044&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc68044"]])

export default __exports__